<template>
  <div class="dialog-wrap">
    <el-dialog title="参考书目"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :modal-append-to-body="false"
               @open="open"
               width="80%">

      <div class="values">
        <div style="display:flex;justify-content: space-between; min-height:60px">

          <el-form class="search-wrap"
                   ref="searchForm"
                   :inline="true"
                   :model="query">
            <el-form-item label="年份"
                          prop="year">
              <el-select v-model="year"
                         clearable
                         style="width:90px;marginLeft:10px"
                         placeholder="请选择"
                         @change="referencePrepareList(true)">
                <el-option label="2027年"
                           value="2027"></el-option>
                <el-option label="2026年"
                           value="2026"></el-option>
                <el-option label="2025年"
                           value="2025"></el-option>
                <el-option label="2024年"
                           value="2024"></el-option>
                <el-option label="2023年"
                           value="2023"></el-option>
                <el-option label="2022年"
                           value="2022"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="院校名称"
                          prop="college_name">
              <el-select v-model="college_keyword"
                         filterable
                         collapse-tags
                         placeholder="请选择"
                         clearable
                         @change="referencePrepareList(true)">
                <el-option v-for="(item, index) in $store.state.collegeList"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学院"
                          prop="reamrk">
              <el-select v-model="apply_academy"
                         placeholder="请选择院校"
                         clearable
                         filterable
                         @change="academyChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in academyList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业"
                          prop="reamrk">
              <el-select v-model="apply_major"
                         placeholder="请选择专业"
                         clearable
                         filterable
                         @change="majorChange"
                         style="width: 100%;">
                <el-option v-for="(item,index) in majorList"
                           :key="index"
                           :label="`（${item.code}）${item.name}`"
                           :value="{ value: item.code, label: item.name}">
                  <span>{{ `（${item.code}）${item.name}` }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 考试科目筛选（已注释）
            <el-form-item label="考试科目"
                          prop="subjects">
              <el-select v-model="subject_code"
                         placeholder="请选择适合科目"
                         clearable
                         style="width:100%;"
                         @change="referencePrepareList(true)">
                <el-option v-for="(item,index) in subjectsList"
                           :key="index"
                           :label="item.subject_name"
                           :value=" item.subject_code">
                </el-option>
              </el-select>
            </el-form-item>
            -->
          </el-form>

          <div style="display:flex;justify-content: flex-end; height:30px;width:400px;">
            <div class="btBox">
              <el-button plain
                         style="marginRight:20px"
                         @click="handleDownload"
                         type="primary">下载模板</el-button>
              <input @change="upload"
                     type="file"
                     name="photoImg"
                     id="getFile"
                     style="display:none;"
                     class="upload-input" />
              <label for="getFile"
                     class="fileStyle">导入</label>

            </div>
            <el-button class="button"
                       @click="secondarAdd"
                       type="primary">新建</el-button>

          </div>

        </div>
        <el-table class="table"
                  :data="results"
                  @selection-change="handleSelectionChange"
                  border>
          <el-table-column type="selection"
                           width="50"
                           align="center"
                           fixed="left">
          </el-table-column>
          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>

          <el-table-column label="院校"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              {{ fmt(scope.row.college_name) }}
            </template>
          </el-table-column>

          <el-table-column label="学院"
                           width="220px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.academy_code, scope.row.academy_name, '(', ')') }}
            </template>
          </el-table-column>
          <el-table-column label="专业"
                           align="center"
                           width="220px"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.major_code, scope.row.major_name, '[', ']') }}
            </template>
          </el-table-column>
          <el-table-column label="方向"
                           width="220px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtCodeName(scope.row.direction_code, scope.row.direction_name, '(', ')') }}
            </template>
          </el-table-column>
          <el-table-column label="学制"
                           width="100px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ fmtEnrolType(scope.row.enrol_type) }}
            </template>
          </el-table-column>

          <el-table-column prop="subject"
                           label="考试科目"
                           width="600"
                           align="left">
            <template slot-scope="scope">
              <span>{{ fmtCodeName(scope.row.subject_code, scope.row.subject_name, '(', ')') }}</span>
              <!-- <span v-if="scope.row.subject_1_code">{{'('+scope.row.subject_1_code + ')' +scope.row.subject_1_name }}</span>
              <span v-if="scope.row.subject_2_code">{{'+('+scope.row.subject_2_code + ')' +scope.row.subject_2_name }}</span>
              <span v-if="scope.row.subject_3_code">{{'+('+scope.row.subject_3_code + ')' +scope.row.subject_3_name}}</span>
              <span v-if="scope.row.subject_4_code">{{'+('+scope.row.subject_4_code + ')' +scope.row.subject_4_name }}</span> -->
            </template>
          </el-table-column>
          <el-table-column prop="reference_books"
                           label="参考书目"
                           width="600"
                           align="left">
            <template slot-scope="scope">
              <span>
                {{ formatBook(scope.row) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="最新更新人"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{ fmt(scope.row.last_update_admin_nickname) }}
            </template>
          </el-table-column>
          <el-table-column prop="update_time"
                           label="更新时间"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ fmtTime(scope.row.update_time, 'YYYY-MM-DD hh:mm') }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="secondarEdit(scope.row)">编辑</el-link> |
              <el-link type="danger"
                       :underline="false"
                       @click="secondarDelele(scope.row)">删除</el-link>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <div class="footer">
        <div>
          <el-button size="mini"
                     type="danger"
                     @click="handleToDeleteAll()">批量删除</el-button>
        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
      <AddReference :visible="addVisible"
                    @close="close"
                    :detail="detail"
                    :rowId="rowId"
                    @submit="referencePrepareList(true)"
                    :title="title"></AddReference>
    </el-dialog>
  </div>
</template>

<script>
import AddReference from '@/components/dialog/admission/addReference'
import {
  referenceBookList,
  referenceBookDelete,
  referenceBooklmport,
} from '@/api/admission'
// import { majorSubjectList } from '@/api/common'
import { collegeMajorList, academyList } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    refereDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    year: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    refereDetail(val) {
      this.detail = val
      this.$set(this.apply_major, 'value', val.major_code)
      this.college_keyword = val.college_code
      console.log('this.detail', this.detail)
    },
  },
  components: {
    AddReference,
  },
  data() {
    return {
      chooseList: [],
      title: '',
      dialogVisible: this.visible,
      addVisible: false,
      pageTotal: 10,
      detail: {},
      rowId: null,
      results: [],
      // subjectsList: [],
      majorList: [],
      academyList: [],
      apply_major: { value: '', label: '' },
      apply_academy: {},
      query: {
        // year:'2025',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      // subject_code: '',
      // filterCode: ['101', '201', '302', '204', '301', '303', '203', '202'],
      college_keyword: '',
    }
  },
  methods: {
    fmt(val) {
      if (val === null || val === undefined) return '--'
      const s = String(val).trim()
      return s === '' ? '--' : val
    },
    fmtCodeName(code, name, left, right) {
      const c = String(code || '').trim()
      const n = String(name || '').trim()
      if (!c && !n) return '--'
      return (c ? `${left}${c}${right}` : '') + n
    },
    fmtEnrolType(val) {
      if (val === null || val === undefined) return '--'
      const s = String(val).trim()
      if (s === '') return '--'
      const map = { 1: '全日制', 2: '非全日制' }
      return map[Number(val)] || '--'
    },
    fmtTime(time, format) {
      if (time === null || time === undefined) return '--'
      const s = String(time).trim()
      if (s === '') return '--'
      return this.$moment(time).format(format || 'YYYY.MM.DD HH:mm')
    },
    // 学院下拉变化
    academyChange() {
      this.referencePrepareList(true)
    },
    // 专业下拉变化
    majorChange() {
      this.referencePrepareList(true)
    },
    // 专业下拉数据
    Majorists() {
      collegeMajorList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.majorList = res.list
      })
    },
    // 学院下拉数据
    getAcademyList() {
      academyList({
        college_code: this.detail.college_code,
        isPaging: 0,
      }).then((res) => {
        this.academyList = res.list
      })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleToDeleteAll() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })
        referenceBookDelete({ ids }).then((res) => {
          this.$message.success('删除成功')
          this.referencePrepareList()
        })
      })
    },
    handleDownload() {
      // 旧地址：https://upload.kaoyanbox.net/aba7bca587e7a8ade529da49ef667cbf.xlsx
      let url =
        'https://upload.kaoyanbox.net/e7bb4225ad2a50bbc8f736f40ed1c715.xlsx'
      let filename = '参考书目文件导入示例文件.xlsx'
      var ajax = new XMLHttpRequest()
      ajax.open('GET', url, true)
      ajax.responseType = 'blob'
      ajax.onload = (e) => {
        let res = e.target.response
        let blob = new Blob([res], { type: res.type }) // 这里的res为后端返回的流数据
        if (window.navigator.msSaveOrOpenBlob) {
          //兼容IE10
          navigator.msSaveBlob(blob, filename)
        } else {
          const href = URL.createObjectURL(blob) //创建新的URL表⽰指定的blob对象
          const a = document.createElement('a') //创建a标签
          a.style.display = 'none'
          a.href = href // 指定下载链接
          a.download = filename //指定下载⽂件名
          a.click() //触发下载
          URL.revokeObjectURL(a.href) //释放URL对象
        }
      }
      ajax.send()
    },
    formatBook(row) {
      const name = String(row.book_name || '').trim()
      const edition = String(row.book_edition || '').trim()
      const author = String(row.book_author || '').trim()
      const publisher = String(row.book_publisher || '').trim()
      const year = String(row.book_year || '').trim()
      const head = []
      if (name) head.push(`《${name}》`)
      if (edition) head.push(`(${edition})`)
      const tail = []
      if (author) tail.push(author)
      if (publisher) tail.push(publisher)
      let str = head.join(' ')
      if (tail.length) {
        str += (str ? ' - ' : '') + tail.join(' / ')
      }
      if (year) {
        str += (str ? '，' : '') + year
      }
      return str || '--'
    },
    // subjectsChange() {
    //   this.$forceUpdate()
    // },
    open() {
      this.referencePrepareList()
      this.$store.dispatch('getAllColleges')
      this.Majorists()
      this.getAcademyList()
      // this.getSubjects()
    },
    referencePrepareList(reset) {
      // 考试科目解析（已注释）
      // let sliceArray = JSON.parse(this.detail.subjects).map((subArr) =>
      //   subArr.slice(2)
      // )
      // console.log(
      //   'JSON.parse(this.detail.subjects)',
      //   JSON.parse(this.detail.subjects)
      // )
      // console.log('this.subjects', sliceArray)
      // const regex = /\((\d+)\)(.+)/
      // const codeSet = new Set(this.filterCode.map(Number)) // 关键点1：转换为数字集合
      // const uniqueMap = new Map()
      // sliceArray.flat().forEach((item) => {
      //   const match = item.match(regex)
      //   if (match) {
      //     const value = parseInt(match[1])
      //     const label = match[2].trim()
      //     // 关键点2：同时去重且过滤
      //     if (!uniqueMap.has(value) && !codeSet.has(value)) {
      //       uniqueMap.set(value, { label, value })
      //     }
      //   }
      // })
      // console.log('3333', Array.from(uniqueMap.values()))
      // let subjectCode = []
      // Array.from(uniqueMap.values()).map((item) => {
      //   subjectCode.push(item.value)
      // })
      const params = Object.assign({}, this.query)
      if (reset) {
        params.pageIndex = 1
      }
      console.log('this.detail', this.detail)
      params.year = this.year
      params.college_code = this.college_keyword
      params.academy_code = this.apply_academy.value
      params.major_code = this.apply_major.value
      // if (this.subject_code) {
      //   params.subject_codes = this.subject_code
      // } else {
      //   // params.subject_codes = subjectCode.join(',')
      //   params.subject_codes = ''
      // }

      referenceBookList(params).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    // getSubjects() {
    //   let query = {
    //     isPaging: 0,
    //     college_code: this.detail.college_code,
    //     major_code: this.detail.major_code,
    //   }
    //   majorSubjectList(query).then((res) => {
    //     this.subjectsList = res.list
    //   })
    // },
    close() {
      this.addVisible = false
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.referencePrepareList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.referencePrepareList()
    },
    handleClose() {
      this.apply_major = {}
      this.apply_academy = {}
      this.$emit('close')
      this.query.pageIndex = 1
    },
    handleExport() {},
    secondarEdit(row) {
      this.rowId = row.id
      this.addVisible = true
      this.title = '编辑参考书目'
    },
    secondarAdd() {
      this.addVisible = true
      this.title = '新建参考书目'
    },
    secondarDelele(row) {
      let id = {
        ids: [row.id],
      }
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定删除',
        type: 'warning',
      }).then((res) => {
        referenceBookDelete(id).then((res) => {
          this.$message.success('操作成功')
          this.referencePrepareList()
        })
      })
    },
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        /******  此处为上传服务器 start   ******/
        let formData = new FormData()
        formData.append('file', file)

        referenceBooklmport(formData).then((res) => {
          console.log('res', res)
          if (res == null) {
            this.$message.success(`导入成功`)
            this.referencePrepareList(true)
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.fileStyle {
  position: relative;

  right: 10px;
  margin-right: 5px;
  border-radius: 1px;
  padding: 6px 15px;
  color: #999999;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #999999;
}
::v-deep .el-upload-list {
  display: none !important;
}
.btBox {
  position: relative;
}
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>
